module.exports = __webpack_public_path__ + "static/media/sound_recordings.f07ba2c9.csv";